import React from 'react'
import useDimensions from 'react-use-dimensions'
import Tooltip from '../../../../ui/tooltips/Tooltip';

const MiniImageList = ({
    images = [],
    children
}) => {
    const [ref, { width }] = useDimensions();

    return (
        <div className="mini-image-list" ref={ref}>
            {images.map((image, index) => {
                return (
                    <span key={index} className="img-container">
                        <Tooltip
                            open
                            text="Image Inserted"
                            placement="top-start"
                            className="image-tooltip"
                            style={{ width }}
                            time={3000}
                        >
                            <img src={image.source} alt="preview" />
                        </Tooltip>
                    </span>
                )
            })}
            {children}
        </div>
    )
}

export default MiniImageList
